<div class="inventory-modal">
    <div class="inventory-modal__header">
      <!--Edit Serial Number-->
  
      <div class="text-block"><h3>Edit Cost</h3>
      </div>
      <i class="material-icons inventory-modal__close-button" (click)="onNoClickPopup()"
        matTooltip="Close Popup">close</i>
  
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field class="mat-input-width">
            <input type="number" matInput name="partCost" [(ngModel)]="inititalCost" #pitch_="ngModel"
              placeholder="Cost">
          </mat-form-field>
      </div>
          <!-- <div class="col-lg-12">
          <mat-form-field class="mat-input-width">
            <input type="number" matInput name="laborCost" [(ngModel)]="LaborCost" #pitch_="ngModel"
              placeholder="Labour Cost">
          </mat-form-field>
          </div>
          <div class="col-lg-12">
          <mat-form-field class="mat-input-width">
            <input type="number" matInput name="MiscCost" [(ngModel)]="MiscCost" #pitch_="ngModel"
              placeholder="Misc Cost">
          </mat-form-field>
          </div> -->
    </div>
    <div class="inventory-modal__footer">
      <button mat-raised-button (click)="onNoClickPopup()">Cancel</button>
      <button mat-raised-button color="warn" [class.loading]="saving"
      (click)="UpdateCost()" >
        <span class="material-icons button__icon">check</span>
        <span class="button__text">Update</span>
      </button>
    </div>
  </div>